export const QueryConfig = {
  refetchOnWindowFocus: false, // Disable re-fetching stale data on window focus
  staleTime: 5000, // The time before data becomes stale (default: 0)
};
